<ng-container [ngSwitch]="state">
    <ng-container *ngSwitchCase="'loading'">
        loading...
    </ng-container>
    <ng-container *ngSwitchCase="'nosession'">
    </ng-container>
    <ng-container *ngSwitchCase="'content'">
        <app-iframe></app-iframe>
    </ng-container>
    <ng-container *ngSwitchCase="'error'">
        <app-iframe technicalError="true"></app-iframe>
    </ng-container>
</ng-container>